import { List as IList } from 'immutable';

export const selectSearchedInterests = (state) => state.interestsReducer.get('companyInterests', IList());

export const selectIndustryInterests = (state) => state.interestsReducer.get('industryInterests', IList());
